import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectBox } from 'cbc-shared-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Sgke051aRequest, Sgke051aResponseBankfcListDto, Sgke051aResponseGamenHyojiInfo, Sgke051aResponseInitialhyojiInfo } from 'sg-api';
import { UsedSgke051aService } from '../../services/used-sgke051a.service';
import { UsedSgke052aService } from '../../services/used-sgke052a.service';
import { ListSearchUtils } from '../../../../../sg-ke-shared/util/list-search-utils';

@Component({
  selector: 'app-sgke050d-regist',
  templateUrl: './sgke050d-regist.component.html',
  styleUrl: './sgke050d-regist.component.scss'
})
export class Sgke050dRegistComponent implements OnInit, OnDestroy {

  /** 未精算金管理番号 */
  @Input() kinkoMno: string;
  /** 未精算金履歴番号 */
  @Input() kinkoRrkno: string;
  /** 返金管理番号 */
  @Input() repayMno: string;
  /** 未精算金_更新通番号 */
  @Input() kinkoUpdateSrno: string;
  /** 未精算金EX_更新通番号 */
  @Input() kinkoexUpdatesequencenumber: string;
  /** 請求お客さま番号 */
  @Input() recptFixNo: string;
  /** 未精算金 */
  @Input() remny: number;

  /** 表示条件フラグ (未精算整理詳細画面から遷移した場合TRUE, 未精算関連承認画面の場合FALSE) */
  @Input() hyojiCndtFlg = true;
  /** 編集可能フラグ (返金方法で"お客様指定口座"が選択された場合TRUE, "口座振替設定口座"が選択された場合FALSE) */
  private isEdit: boolean = false;

  /** メッセージエミッター */
  @Output() msgEmit = new EventEmitter();
  /** メッセージエリアクリアエミッター */
  @Output() clearMessageEmit = new EventEmitter();
  /** SGKE020D再描画（再検索）エミッター */
  @Output() searchEmit = new EventEmitter();
  /** 閉じるボタン押下イベント*/
  @Output() clickModalCloseEvent = new EventEmitter();

  /** 初期表示APIリクエスト */
  private request051a: Sgke051aRequest;
  /** 画面表示情報_検索結果 */
  public gamenHyojiInfo: Sgke051aResponseGamenHyojiInfo;
  /** 初期表示情報_検索結果 */
  private initialhyojiInfo: Sgke051aResponseInitialhyojiInfo;

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /** 返金方法リスト */
  repayMethodList: SelectBox[] = [];
  /** 預金種別リスト */
  kouzayokinSyubetuList: SelectBox[] = [];
  /** 返金元口座設定リスト */
  henkinmotoKouzaList: SelectBox[] = [];

  /** 金融機関名リスト */
  bankfcAnameList: SelectBox[] = [];
  /** 支店名リスト */
  branchAnameList: SelectBox[] = [];
  /** 金融機関名 */
  bankfcAname: string = '';
  /** 支店名 */
  branchAname: string = '';

  /** SGKE051Aレスポンス_金融機関名リスト */
  sgke051aResponseBankfcListDto: Sgke051aResponseBankfcListDto[];

  /** 返金方法登録APIリクエストDto FormGroup */
  refundReqInfDto: UntypedFormGroup;
  /** 登録条件 FormGroup */
  regCndt: UntypedFormGroup;
  /** 返金依頼情報（返金先口座情報） FormGroup */
  repayReqInfo: UntypedFormGroup;
  /** 預り金情報 FormGroup */
  depInfo: UntypedFormGroup;
  /** 未入金情報（マイナス調定) */
  nrcvmnyInfoMinuschotei: UntypedFormGroup;

  /**
   * コンストラクタ
   * @param {UntypedFormBuilder} fb
   * @param {UsedSgke051aService} searchService
   * @param {UsedSgke052aService} registService
   * @memberof Sgke050dRegistComponent
   */
  constructor(
    private fb: UntypedFormBuilder,
    public searchService: UsedSgke051aService,
    public registService: UsedSgke052aService,
    public listUtils: ListSearchUtils,
  ) { }

  /**
   * 初期表示
   * @memberof Sgke050dRegistComponent
   */
  ngOnInit(): void {
    // フォームを作成
    this.createForm();

    // 初期検索実行
    this.onInitSearch();
  }

  /**
   * 購読解除
   * @memberof Sgke050dViewComponent
   */
  ngOnDestroy() {
    this.onDestroy$.next();
    this.refundReqInfDto.clearValidators();
    this.refundReqInfDto.updateValueAndValidity();
  }

  /**
   * フォーム作成
   * @memberof Sgke050dRegistComponent
   */
  private createForm() {
    // 返金依頼情報（返金先口座情報） FormGroup
    this.repayReqInfo = this.fb.group({
      // 【入力しない要素】
      // 返金先口座_返金方法コード（返金方法SelectList）
      rpaytokouzaRepaywayCode: this.fb.nonNullable.control({ value: '', disabled: !this.hyojiCndtFlg }, Validators.required),
      // 返金元口座コード（返金元口座設定SelectList）
      refundsourceKouzaCode: this.fb.nonNullable.control({ value: '1', disabled: !this.hyojiCndtFlg }, Validators.required),
      // 返金方法区分
      repayMethodDiv: [{ value: '1', disabled: true }],
      // 返金額
      repayMny: [{ value: '', disabled: true }, Validators.required],
      // 返金先口座設定区分
      rpaytoAccntSetupd: [{ value: '', disabled: true }],

      // 【入力する要素】
      // 口座名義（カナ）
      kouzaMeigiKana: [{ value: '', disabled: !this.hyojiCndtFlg }, [Validators.required, Validators.minLength(1), Validators.maxLength(30)]],
      // 口座名義（漢字）
      kohuriActknj: [{ value: '', disabled: !this.hyojiCndtFlg }, [Validators.required, Validators.minLength(1), Validators.maxLength(24)]],
      // 金融機関コード
      extBankfcCode: [{ value: '', disabled: !this.hyojiCndtFlg }, [Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.pattern(/^[0-9]+$/)]],
      // 支店コード
      extBranchCode: [{ value: '', disabled: !this.hyojiCndtFlg }, [Validators.required, Validators.minLength(3), Validators.maxLength(3), Validators.pattern(/^[0-9]+$/)]],
      // 預金種別
      kouzaDptclsDivcd: this.fb.nonNullable.control({ value: '', disabled: !this.hyojiCndtFlg }, Validators.required),
      // 口座番号
      kouzaNo: [{ value: '', disabled: !this.hyojiCndtFlg }, [Validators.required, Validators.minLength(7), Validators.maxLength(7), Validators.pattern(/^[0-9]+$/)]],
    });

    // 預り金情報 FormGroup
    this.depInfo = this.fb.group({
      // 未精算金管理番号
      kinkoMno: [{ value: this.kinkoMno, disabled: true }],
      // 未精算金履歴番号
      kinkoRrkno: [{ value: this.kinkoRrkno, disabled: true }],
      // 未精算金_更新通番号
      kinkoUpdateSrno: [{ value: this.kinkoUpdateSrno, disabled: true }],
      // 未精算金EX_更新通番号
      kinkoexUpdatesequencenumber: [{ value: this.kinkoexUpdatesequencenumber, disabled: true }],
    });

    /** 未入金情報（マイナス調定) */
    this.nrcvmnyInfoMinuschotei = this.fb.group({
      // 発行年月
      hakkoYmt: [{ value: null, disabled: true }],
      // 請求料金番号
      claimChargeNo: [{ value: null, disabled: true }],
    });

    // 登録条件 FormGroup
    this.regCndt = this.fb.group({
      // 請求お客さま番号
      recptFixNo: [{ value: this.recptFixNo, disabled: true }],
      // 返金依頼情報（返金先口座情報） FormGroup
      repayReqInfo: this.repayReqInfo,
      // 預り金情報 FormGroup
      depInfo: this.depInfo,
      // 未入金情報（マイナス調定)
      nrcvmnyInfoMinuschotei: this.nrcvmnyInfoMinuschotei
    });

    // 返金方法登録APIリクエストDto FormGroup
    this.refundReqInfDto = this.fb.group({
      // リクエスト共通エリア FormGroup
      requestCommon: new UntypedFormGroup({}),
      // 登録条件 FormGroup
      regCndt: this.regCndt,
    });
  }

  private onInitSearch() {
    // sgke051aのリクエスト情報をもつオブジェクトを定義
    this.request051a = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      initialhyojiCndt: {
        hyojiCndtFlg: this.hyojiCndtFlg,
        kinkoMno: this.kinkoMno,
        kinkoRrkno: this.kinkoRrkno,
        repayMno: this.repayMno,
        recptFixNo: this.recptFixNo
      }
    };

    // SGKE051A呼び出し
    this.searchService.doSgke051a(this.request051a).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response?.gamenHyojiInfoDto) {
          this.gamenHyojiInfo = response.gamenHyojiInfoDto;
          this.initialhyojiInfo = response.initialhyojiInfoDto;
          this.setSelectList();
          this.setBankfcAndBranchList();
          this.gamenControl();
          this.setFormSgke051a();
          this.repayReqInfo.controls.repayMny.setValue(this.gamenHyojiInfo.basicInfoDto.repayMny);
        }
        // メッセージを表示
        if (response?.responseCommon?.errors?.length > 0) {
          this.msgEmit.emit(response?.responseCommon?.errors);
        }
      },
      error => {
      }
    );
  }

  /**
   * 選択リストに値を設定
   * @memberof Sgke050dRegistComponent
   */
  private setSelectList() {
    // 返金方法リスト
    this.repayMethodList = this.initialhyojiInfo.repayMethodListDto.map((repayMethod) => {
      let selectBox: SelectBox = {
        value: repayMethod.codeValue,
        viewValue: repayMethod.aname
      };
      return selectBox;
    });
    // 預金種別リスト
    this.kouzayokinSyubetuList = this.initialhyojiInfo.dptClsfyListDto.map((kouzayokinSyubetu) => {
      let selectBox: SelectBox = {
        value: kouzayokinSyubetu.codeValue,
        viewValue: kouzayokinSyubetu.aname
      };
      return selectBox;
    });
    // 返金元口座設定リスト
    this.henkinmotoKouzaList = this.initialhyojiInfo.refundsourcekouzaSettingListDto.map((refundsourcekouzaSetting) => {
      let selectBox: SelectBox = {
        value: refundsourcekouzaSetting.codeValue,
        viewValue: refundsourcekouzaSetting.aname
      };
      return selectBox;
    });
  }

  /**
   * 金融機関名と支店名リストをSGKE051Aレスポンスから設定
   * @private
   * @memberof Sgke050dRegistComponent
   */
  private setBankfcAndBranchList() {
    // SGKE051Aレスポンス_金融機関名リスト設定
    this.sgke051aResponseBankfcListDto = this.initialhyojiInfo.bankfcListDto;

    // 金融機関名リスト設定
    this.bankfcAnameList = this.sgke051aResponseBankfcListDto.map((bankfc) => {
      let selectBox: SelectBox = {
        value: bankfc.codeValue,
        viewValue: bankfc.aname
      };
      return selectBox;
    });
  }

  /**
   * 画面表示制御呼び出し
   * @memberof Sgke050dRegistComponent
   */
  private gamenControl() {
    if (this.hyojiCndtFlg) {
      this.onChangeSelect(this.gamenHyojiInfo?.rpaytoKouzaDto?.repayMethodDto?.codeValue);
      // 初回APIレスポンス時のみ、返金方法セレクターの初期値を設定する
      this.repayReqInfo.controls.rpaytokouzaRepaywayCode.setValue(this.gamenHyojiInfo?.rpaytoKouzaDto?.repayMethodDto?.codeValue == '2' ? '2' : '1');
    }
  }

  /**
   * フォームにSGKE051Aのレスポンスの値をセット
   * @memberof Sgke050dRegistComponent
   */
  private setFormSgke051a() {
    this.repayReqInfo.controls.kohuriActknj.setValue(this.gamenHyojiInfo.rpaytoKouzaDto.kohuriActknj);
    this.repayReqInfo.controls.kouzaMeigiKana.setValue(this.gamenHyojiInfo.rpaytoKouzaDto.kouzaMeigiKana);
    this.repayReqInfo.controls.extBankfcCode.setValue(this.gamenHyojiInfo.rpaytoKouzaDto.bankfcDto.codeValue);
    this.repayReqInfo.controls.extBranchCode.setValue(this.gamenHyojiInfo.rpaytoKouzaDto.branchDto.codeValue);
    var kouzaDptclsDivcd = this.listUtils.getListboxValue(this.gamenHyojiInfo.rpaytoKouzaDto.dptClsfyDto.codeValue, this.kouzayokinSyubetuList);
    this.repayReqInfo.controls.kouzaDptclsDivcd.setValue(kouzaDptclsDivcd);
    this.repayReqInfo.controls.kouzaNo.setValue(this.gamenHyojiInfo.rpaytoKouzaDto.kouzaNo);
    this.bankfcAname = this.gamenHyojiInfo.rpaytoKouzaDto.bankfcDto.aname ?? '';
    this.branchAname = this.gamenHyojiInfo.rpaytoKouzaDto.branchDto.aname ?? '';
    var refundsourceKouzaCode = this.listUtils.getListboxValue(this.gamenHyojiInfo.refundsourceKouzaDto.refundsourcekouzaSettingDto.codeValue, this.henkinmotoKouzaList);
    this.repayReqInfo.controls.refundsourceKouzaCode.setValue(refundsourceKouzaCode);
    if (!this.hyojiCndtFlg) {
      this.repayReqInfo.controls.rpaytokouzaRepaywayCode.setValue(this.gamenHyojiInfo.rpaytoKouzaDto.repayMethodDto.codeValue);
    }
  }

  /**
   * 登録ボタン押下時
   * @memberof Sgke050dRegistComponent
   */
  public onRegist(): void {
    this.clearMessageEmit.emit();

    this.registService.doSgke052a(this.refundReqInfDto.getRawValue())
      .pipe(takeUntil(this.onDestroy$)).subscribe(
        response => {
          if (response) {
            // メッセージを表示
            if (response?.responseCommon?.errors?.length > 0) {
              this.msgEmit.emit(response?.responseCommon?.errors);
            }
            // SGKE020D_未精算整理詳細画面の再描画
            this.searchEmit.emit();
          }
        },
        error => {
        }
      );
  }

  /**
   * 返金方法セレクター選択時の画面表示制御
   * @param {*} [value]
   * @memberof Sgke050dRegistComponent
   */
  public onChangeSelect(value?) {
    // 値の設定
    //お客様指定口座（口座振替）
    if (value == '2') {
      this.bankfcAname = '';
      this.branchAname = '';
      // 返金元口座設定を初期値の「センター管理口座」に戻す
      this.repayReqInfo.controls.refundsourceKouzaCode.reset();
      this.isEdit = true;
      //口座振替設定口座
    } else {
      this.setFormSgke051a();
      this.isEdit = false;
    }

    // 返金先口座設定区分の設定
    let rpaytoAccntSetupd = value == '1' ? '1' : '2';
    this.repayReqInfo.controls.rpaytoAccntSetupd.setValue(rpaytoAccntSetupd);

    // enable/disable切り替え項目
    const inputFieldList = [
      'kohuriActknj',
      'kouzaMeigiKana',
      'extBankfcCode',
      'extBranchCode',
      'kouzaDptclsDivcd',
      'kouzaNo',
    ];

    inputFieldList.forEach((inputField) => {
      let ctl = this.repayReqInfo.controls[inputField];
      if (this.isEdit) {
        // 有効無効を設定
        ctl.enable();
        ctl.reset();
      } else {
        ctl.disable();
      }
    });
  }

  /**
   * 入力欄のデザイン切り替え
   * @param {string} ctrlName
   * @return {*}
   * @memberof Sgke050dRegistComponent
   */
  public getAppearance(ctrlName: string) {
    const enabled = this.repayReqInfo.controls[ctrlName]?.enabled;
    return enabled ? 'outline' : 'fill';
  }

  /**
   * 閉じるボタン押下時処理
   * @memberof Sgke050dRegistComponent
   */
  public onClickModalClose(): void {
    this.clickModalCloseEvent.emit();
  }

  /**
   * 金融機関コード入力時に金融機関名を検索・表示
   * @param {Event} event
   * @memberof Sgke050dRegistComponent
   */
  public onInputBankfcAname(event: Event) {
    let inputValue = (event.target as HTMLInputElement).value;
    this.bankfcAname = '';
    if (inputValue.length == 4) {
      this.bankfcAname = this.bankfcAnameList.filter(bankfcAname => bankfcAname.value == inputValue)[0]?.viewValue ?? '';
    }
    // 入力した金融機関コードに対応する金融機関名がリスト存在する場合、その金融機関の支店名リストをセットする
    if (this.bankfcAname) {
      // 入力された金融機関コードとマッチするSGKE051Aレスポンス_金融機関名リストを取得
      const selectedBankfc = this.sgke051aResponseBankfcListDto.find(bankfc => bankfc.codeValue == inputValue);

      // 支店名リスト設定
      this.branchAnameList = selectedBankfc.branchListDto.map((branch) => {
        let selectBox: SelectBox = {
          value: branch.codeValue,
          viewValue: branch.aname
        };
        return selectBox;
      });

      // 金融機関コード入力時に支店コードに入力されている値を取得
      let enteredBranchCd = this.repayReqInfo.controls.extBranchCode.getRawValue()
      this.onInputBranchAname(null, enteredBranchCd);

    }

  }

  /**
   * 支店コード入力時に支店名を検索・表示
   * @param {Event} event
   * @param {string} [branchCd='']
   * @memberof Sgke050dRegistComponent
   */
  public onInputBranchAname(event: Event, branchCd: string = '') {
    let inputValue: string;

    if (event) {
      inputValue = (event.target as HTMLInputElement).value;
    } else {
      inputValue = branchCd;
    }

    this.branchAname = '';
    if (inputValue.length == 3) {
      this.branchAname = this.branchAnameList.filter(branchAname => branchAname.value == inputValue)[0]?.viewValue ?? '';
    }
  }

}
